import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BusinessIcon from "@mui/icons-material/Business";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import "../ComponentCss/SubHeader.css";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PermMediaIcon from '@mui/icons-material/PermMedia';

export default function SubHeader() {
  const [open, setOpen] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const location = useLocation();

  React.useEffect(() => {
    const path = location.pathname;
    // console.log(path);
    if (path.includes("/ManageTender")) {
      setSelectedItem("Tender Management");
    } 
    else if (path.includes("/AddTender")) {
      setSelectedItem("Tender Management");
    }
    else if (path.includes("/UpdateTender")) {
      setSelectedItem("Tender Management");
    }
     else if (path.includes("/ManageProject")) {
      setSelectedItem("Project Management");
    } 
    else if (path.includes("/AddProject")) {
      setSelectedItem("Project Management");
    } 
    else if (path.includes("/LineItems")) {
      setSelectedItem("Project Management");
    } 
    else if (path.includes("/AddPurchase")) {
      setSelectedItem("Purchase Order");
    } 
    else if (path.includes("/ManagePurchase")) {
      setSelectedItem("Purchase Order");
    } 
    else if (path.includes("/POLineItem")) {
      setSelectedItem("Purchase Order");
    } 
    else if (path.includes("/AddVendor")) {
      setSelectedItem("Vendor Management");
    } 
    else if (path.includes("/ManageVendor")) {
      setSelectedItem("Vendor Management");
    }
    else if (path.includes("/updatevendor")) {
      setSelectedItem("Vendor Management");
    } 
    else if (path.includes("/AddCompany")) {
      setSelectedItem("Vendor Management");
    } 
    else if (path.includes("/ManageCompany")) {
      setSelectedItem("Vendor Management");
    }
    else if (path.includes("/updateCompany")) {
      setSelectedItem("Vendor Management");
    }
    else if (path.includes("/AddReceipt")) {
      setSelectedItem("Purchase Order");
    }
    else if (path.includes("/ManageReceipt")) {
      setSelectedItem("Purchase Order");
    }
    else if (path.includes("/ROLineItem")) {
      setSelectedItem("Purchase Order");
    } 
    else if (path.includes("/AddMaterial")) {
      setSelectedItem("Product");
    } 
    else if (path.includes("/ManageMaterial")) {
      setSelectedItem("Product");
    } 
    else if (path.includes("/UpdateMaterial")) {
      setSelectedItem("Product");
    } 
    else if (path.includes("/AddTools")) {
      setSelectedItem("Product");
    } 
    else if (path.includes("/ManageTools")) {
      setSelectedItem("Product");
    } 
    else if (path.includes("/UpdateTools")) {
      setSelectedItem("Product");
    } 
    else if (path.includes("/InventoryTranscation")) {
      setSelectedItem("Inventory");
    } 
    else if (path.includes("/InventoryOnHand")) {
      setSelectedItem("Inventory");
    }
    else if (path.includes("/ToolsTransactions")) {
      setSelectedItem("Inventory");
    } 
    else if (path.includes("/ToolsInventoryOnHand")) {
      setSelectedItem("Inventory");
    } 
    else if (path.includes("/ManageWorkOrder")) {
      setSelectedItem("Work Order");
    }
    else if (path.includes("/AddWorkOrder")) {
      setSelectedItem("Work Order");
    }
    else if (path.includes("/ManageMatWorkOrder")) {
      setSelectedItem("Work Order");
    }
    else if (path.includes("/AddMatWorkOrder")) {
      setSelectedItem("Work Order");
    }
    else if (path.includes("/UpdateWorkOrder")) {
      setSelectedItem("Work Order");
    }
    else if (path.includes("/FileUpload")) {
      setSelectedItem("File Upload");
    }
    else {
      setSelectedItem(null);
    }
  }, [location]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleListItemClick = (item) => () => {
    setSelectedItem(item);
    setOpen(false); // Close the drawer after selection
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        <ListItem
          disablePadding
          onClick={handleListItemClick("Tender Management")}
        >
          <Link
            to="/ManageTender"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <AssignmentIcon /> {/* Tender Management Icon */}
              </ListItemIcon>
              <ListItemText primary="Tender Management" />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem
          disablePadding
          onClick={handleListItemClick("Project Management")}
        >
          <Link
            to="/ManageProject"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <BusinessIcon /> {/* Project Management Icon */}
              </ListItemIcon>
              <ListItemText primary="Project Management" />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem disablePadding onClick={handleListItemClick("Inventory")}>
        <Link
            to="/InventoryTranscation"
            style={{ textDecoration: "none", color: "inherit" }}
          >
          <ListItemButton>
            <ListItemIcon>
              <InventoryIcon />
            </ListItemIcon>
            <ListItemText primary="Inventory" />
          </ListItemButton>
        </Link>
        </ListItem>

        <ListItem
          disablePadding
          onClick={handleListItemClick("Vendor Management")}
        >
          <Link
            to="/ManageVendor"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <LocalShippingIcon /> {/* Vendor Management Icon */}
              </ListItemIcon>
              <ListItemText primary="Vendor & Customer" />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem disablePadding onClick={handleListItemClick("Purchase Order")}>
          <Link
            to="/ManagePurchase"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <ShoppingCartIcon /> {/* Purchase Order Icon */}
              </ListItemIcon>
              <ListItemText primary="Purchase Order" />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem disablePadding onClick={handleListItemClick("Product")}>
          <Link
            to="/ManageMaterial"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <PrecisionManufacturingIcon /> {/* Product Icon */}
              </ListItemIcon>
              <ListItemText primary="Material & Tools" />
            </ListItemButton>
          </Link>
        </ListItem>



        <ListItem disablePadding onClick={handleListItemClick("Work Order")}>
          <Link
            to="/ManageWorkOrder"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <MapsHomeWorkIcon /> {/*  Work Order Icon */}
              </ListItemIcon>
              <ListItemText primary="Work Order" />
            </ListItemButton>
          </Link>
        </ListItem>

        <ListItem disablePadding onClick={handleListItemClick("File Storage")}>
          <Link
            to="/FileUpload"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <ListItemButton>
              <ListItemIcon>
                <PermMediaIcon /> 
              </ListItemIcon>
              <ListItemText primary="File Upload" />
            </ListItemButton>
          </Link>
        </ListItem>


      </List>
      <Divider />
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 2, mt: 10 }}>
      <AppBar
        position="fixed"
        sx={{ top: 48, zIndex: (theme) => theme.zIndex.drawer + 0 }}
        className="custom-subHeader"
      >
        <Toolbar variant="dense">
          <IconButton
            edge="start"
            color="white"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <div>
              <Button onClick={toggleDrawer(true)} style={{ color: "white" }}>
                <MenuIcon />
              </Button>
              <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
              </Drawer>
            </div>
          </IconButton>

          {(selectedItem === "Tender Management" ||
            selectedItem === "Project Management") && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageTender">
                  Tender
                </Link>
              </Typography>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageProject">
                  Project
                </Link>
              </Typography>
            </>
          )}

          {selectedItem === "Vendor Management" && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageVendor">
                  Vendor
                </Link>
              </Typography>

              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageCompany">
                  Customer
                </Link>
              </Typography>
            </>
          )}

          {selectedItem === "Purchase Order" && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManagePurchase">
                  PurchaseOrder
                </Link>
              </Typography>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
              
                <Link className="link" to="/ManageReceipt">
                    Receipts
                  </Link>
              </Typography>
            </>
          )}

          {selectedItem === "Product" && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageMaterial">
                  Material
                </Link>
              </Typography>

              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageTools">
                  Tools
                </Link>
              </Typography>
            </>
          )}

          {selectedItem === "Inventory" && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/InventoryTranscation">
                  InventoryTransactions
                </Link>
              </Typography>

              
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
              
                <Link className="link" to="/InventoryOnHand">
                    InventoryOnHand
                  </Link>
              </Typography>

              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
              
                <Link className="link" to="/ToolsTransactions ">
                    ToolsTransactions 
                  </Link>
              </Typography>

              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
              
                <Link className="link" to="/ToolsInventoryOnHand">
                ToolsInventoryOnHand 
                  </Link>
              </Typography>
              
            </>
          )}

          {selectedItem === "Work Order" && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageWorkOrder">
                  Work Order
                </Link>
              </Typography>

              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageWorkOrderTransactions">
                WorkOrderTransactions
                </Link>
              </Typography>

              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/ManageMatWorkOrder">
                ManageMaterialWorkOrder
                </Link>
              </Typography>


            </>
          )}

          {selectedItem === "File Upload" && (
            <>
              <Typography
                variant="h6"
                color="white"
                component="div"
                sx={{ mr: 2, fontSize: 15 }}
              >
                <Link className="link" to="/FileUpload">
                  Attachments
                </Link>
              </Typography>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
